/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';

import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostUploadImage extends ResponseREST {
  data: any[];
}

export const postUploadImageAndItem = async (
  FormData: FormData
): Promise<ResponseSuccessPostUploadImage> => {
  return await axiosInstance
    .post('api/stock-waste-document-mobile/upload-item-and-image-waste', FormData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
    .then((res: AxiosResponse<ResponseSuccessPostUploadImage>) => res.data);
};
